import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, NavigationExtras } from '@angular/router';
import { DspxCardSetBaseFormComponent, SpinnerService, DialogService, CoreService, DialogResult } from 'dspx-core';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { VptasSubsidyGridFilterRequest } from 'src/app/interfaces/vptas-subsidy-grid-filter-request.interface';
import { POP_UP_CODES, SAVE_RESULT_STATUS } from 'src/app/constants/app-data.constants';
import { finalize, take } from 'rxjs';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';

@Component({
  selector: 'app-vptas-application-trip-list',
  templateUrl: './vptas-application-trip-list.component.html',
  styleUrl: './vptas-application-trip-list.component.scss'
})
export class VptasApplicationTripListComponent  extends BaseCardSetListComponent implements OnInit, OnDestroy  {
  selectedRowId: any;
  itemMode: string = '';
  startDate: any;
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  applicationId: string = '';
  activeDialog: string = '';

  constructor(
      protected router: Router,
      protected route: ActivatedRoute,
      protected spinnerService: SpinnerService,
      protected dialogService: DialogService,
      protected responseParserService: ResponseParserService,
      protected appDataService: AppDataService,
      private coreService: CoreService,
      private errorService: ErrorService,
    ) {
      super(
        router,
        spinnerService,
        dialogService,
        responseParserService,
        appDataService,
        TEMPLATES.victorianPatientTransportAssistanceSchemeApplicationTripList,
        () => {
          return API_ENDPOINTS.dashboard.getVptasApplicationTripList
        },
        false);
  }

  ngOnInit(): void {
   this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const applicationId = paramMap.get('id');
        if (applicationId) {
          this.applicationId = applicationId;
        }
      })
    );
  this.coreService.applicationFunctions = {
      exit: () => this.navigateBack(),
    };
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  filterData(event: any): void {
  }
  
  formLoad(event: any): void {
    this.loadGridDataOnFormLoad(this.getAdjustmentFilterRequest());
  }

  private getAdjustmentFilterRequest(): VptasSubsidyGridFilterRequest {
      return {
        ApplicationId: this.applicationId
      };
    }
    
  actionButton_partialPaymentGrid_datagrid_createAdjustment_Clicked(event: any): void {
    this.selectedRowId=event?.event?.data?.id;
    this.itemMode =event?.event?.data?.mode;
    this.startDate =event?.event?.data?.startDate;
        this.activeDialog = POP_UP_CODES.vptasApplicationDetails.partialPaymentPopup;
        this.dialogService.showDialog(this.activeDialog);
  }

  actionButton_partialPaymentGrid_datagrid_createPartialPayment_Clicked(event: any): void {
   this.selectedRowId=event?.event?.data?.id;
   this.itemMode =event?.event?.data?.mode;
   this.startDate =event?.event?.data?.startDate;
   console.log(this.selectedRowId);
        const popupCode  = POP_UP_CODES.vptasApplicationDetails.revertPartialPayment;
    
        this.dialogService
          .showConfirm(popupCode).subscribe(data => {
          if (data === DialogResult.ACCEPTED) {
            this.updateTreatmentItemPaymentEligibility(false, null,null);
          }
        });
         
  }

  dialogButton_partialPaymentPopup_Clicked($event: any): void {
    this.updateTreatmentItemPaymentEligibility(true, $event?.applicationIneligibleReasonTypeId,$event.otherReason);
  }

  private updateTreatmentItemPaymentEligibility(isPartialPaymentExcluded: boolean, applicationIneligibleReasonTypeId: any, partialPaymentOther: any): void {
    const payload = { 
      id: this.selectedRowId,
      applicationId: this.applicationId,
      isPartialPaymentExcluded: isPartialPaymentExcluded,
      tripMode: this.itemMode,
      partialPaymentReason: applicationIneligibleReasonTypeId,
      partialPaymentOtherReason: partialPaymentOther,
      tripDate: this.startDate
    };
    
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.appDataService
        .post(API_ENDPOINTS.vptasApplicationDetails.updateTreatmentItemPaymentEligibility, payload)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(response => {
          this.loadGridDataOnFormLoad(this.getAdjustmentFilterRequest());
        })
    );
  }
  private navigateBack() {
      const navExtras = this.getNavigationExtras();
      this.router.navigate(['/', ROUTE_CONSTANTS.vptasApplication.prefix, ROUTE_CONSTANTS.vptasApplication.details.prefix, this.applicationId], navExtras);
    }
  
    private getNavigationExtras(): NavigationExtras {
      return {
        state: {
          applicationFilterRequest: history.state.applicationFilterRequest,
          }
        };
    }
}
